/* eslint-disable @typescript-eslint/naming-convention */
export enum DatePickerPresentationTypeEnum {
	Date = 'date',
	DateTime = 'date-time',
	Time = 'time'
}
